module.exports = "/img/d5083d482350f407cf0b0968790cfbfd.svg";